export const DialogsUserSettingsOptions = {
  IMPORT_EXPORT_ORDERS_VOLUME: 1,
  MANUAL_ORDER: 2,
  RELEASE: 3,
  CONFIGURATION: 4,
  IMPORT_EXPORT_BOTTLES: 5,
  SCHEDULE_NOTIFICATION_EMAIL_SENDING: 6
}
